// Mock data aligned with Corporate Governance Review System - Self-Directed Review

export const mockData = {
  hero: {
    title: "The Corporate Governance Review System",
    subtitle: "Self-Directed Review",
    description: "Conduct a full professional governance review without hiring a £5,000–£15,000 consultant. Structured 4-phase methodology. Evidence-based. Consultant-grade reporting.",
    ctaText: "Book a Qualifying Call",
    image: "https://customer-assets.emergentagent.com/job_diy-governance-pro/artifacts/s7u1886j_Acquisition%20Alchemy%20%20%28500%20x%20500%20px%29%20%2810%29.png"
  },

  phases: [
    {
      id: 1,
      title: "Planning & Scoping",
      description: "Define review objectives, scope boundaries, stakeholder mapping, and establish your governance review framework.",
      deliverables: ["Review charter", "Stakeholder matrix", "Timeline plan"]
    },
    {
      id: 2,
      title: "Documentation & Structural Review",
      description: "Systematic assessment of governing documents, board minutes, policies, risk registers, and organisational structure.",
      deliverables: ["Document analysis", "Gap assessment", "Evidence log"]
    },
    {
      id: 3,
      title: "Effectiveness & Culture Assessment",
      description: "Structured interview frameworks for Chair, CEO, and Trustees. Evaluate board dynamics and governance culture.",
      deliverables: ["Interview guides", "Culture assessment", "Effectiveness scores"]
    },
    {
      id: 4,
      title: "Findings & Improvement Planning",
      description: "Synthesise findings into RAG-rated recommendations, risk classification matrix, and improvement roadmaps.",
      deliverables: ["Executive report", "Risk matrix", "Action roadmap"]
    }
  ],

  benefits: [
    {
      id: 1,
      title: "Real-Time Collaboration",
      description: "Invite up to 5 team members. Work together on assessments, track progress, and share insights across your governance team.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Consultant-Grade Reports",
      description: "Generate professional governance review reports with executive summaries, RAG ratings, and prioritised recommendations.",
      icon: "FileDown"
    },
    {
      id: 3,
      title: "UK Charity Aligned",
      description: "Methodology aligned with Charity Commission requirements, the Charity Governance Code, and UK sector best practice.",
      icon: "RefreshCw"
    },
    {
      id: 4,
      title: "Save Significant Costs",
      description: "Replace expensive consultancy fees with our structured self-directed system. Conduct unlimited reviews with lifetime access.",
      icon: "PiggyBank"
    }
  ],

  features: [
    "Lifetime access",
    "Up to 5 team members",
    "Unlimited reviews",
    "Professional reports",
    "Evidence management",
    "Priority support"
  ],

  faqs: [
    {
      id: 1,
      question: "What is GovernWell?",
      answer: "GovernWell is a self-led governance review system that helps organisations assess governance effectiveness, identify improvement opportunities, and build structured governance improvement plans."
    },
    {
      id: 3,
      question: "How does GovernWell compare to hiring a consultant?",
      answer: "GovernWell gives organisations the structure, methodology, and tools typically delivered through governance consultancy engagements, enabling reviews to be conducted internally at a fraction of the cost."
    },
    {
      id: 4,
      question: "How long does the review process take?",
      answer: "Most organisations can complete an initial review within a few weeks and then use the platform to manage governance improvement on an ongoing basis."
    }
  ]
};

// Mock authentication functions
export const mockAuth = {
  signup: async (email, password, orgName) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(`Mock signup: ${email}, ${orgName}`);
        resolve({
          success: true,
          user: { id: "mock_user_1", email, orgName },
          token: "mock_jwt_token",
          message: "Account created! Redirecting to dashboard..."
        });
      }, 1000);
    });
  },

  login: async (email, password) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log(`Mock login: ${email}`);
        resolve({
          success: true,
          user: { id: "mock_user_1", email, orgName: "Test Charity" },
          token: "mock_jwt_token",
          message: "Login successful!"
        });
      }, 1000);
    });
  },

  logout: () => {
    console.log("Mock logout");
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  }
};

// Mock dashboard data - aligned with 4-phase review system
export const mockDashboard = {
  organization: {
    name: "Test Charity Organization",
    members: 3,
    maxMembers: 5,
    subscription: "active",
  },
  
  currentReview: {
    id: "review_001",
    name: "Annual Governance Review 2025",
    status: "in_progress",
    currentPhase: 1,
    progress: 0,
    createdAt: "2025-01-01"
  },

  phases: [
    {
      id: 1,
      name: "Planning & Scoping",
      status: "not_started",
      progress: 0
    },
    {
      id: 2,
      name: "Documentation Review",
      status: "locked",
      progress: 0
    },
    {
      id: 3,
      name: "Effectiveness Assessment",
      status: "locked",
      progress: 0
    },
    {
      id: 4,
      name: "Findings & Planning",
      status: "locked",
      progress: 0
    }
  ],

  recentActivity: [
    {
      id: 1,
      user: "You",
      action: "Started governance review",
      timestamp: "2 hours ago"
    }
  ]
};
